
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 500.3 500.3"}, attrs),
              ...rest,
            },
            children.concat([_c('ellipse',{attrs:{"cx":"231.4","cy":"80.9","rx":"225.7","ry":"58.5","fill":"currentColor"}}),_c('path',{attrs:{"d":"M71.4 201.5a568 568 0 00160 20.6c128-1.2 188-31 188-31 24.3-10.4 38.2-21.8 38.2-32.2v-47.4c0-.6 0-1.1-.2-1.7-7.9 13.2-27.5 23-45.5 29.7v30.1a7.5 7.5 0 11-15 0v-25l-12 3.3v36.5a10 10 0 11-20 0v-32.2c-37.5 7-83.6 11.2-133.5 11.2-118.6 0-216-23.5-226-53.6l-.2 1.7v48.4c0 13.9 24.8 29.4 66.2 41.6zM500.1 239c-7.9 13-27.5 23-45.5 29.6v30.1a7.5 7.5 0 11-15 0v-25a289 289 0 01-12 3.3v36.4a10 10 0 11-20 0v-32.1c-37.5 7-83.6 11.2-133.5 11.2-118.6 0-216-23.5-226-53.6-.2.6-.2 1.1-.2 1.7V289c0 13.9 24.7 29.4 66.2 41.6a568 568 0 00160 20.6c128-1.2 188-31 188-31 24.3-10.4 38.2-21.8 38.2-32.2v-47.4c0-.6 0-1.1-.2-1.7zM226.2 419.2c-50 0-96-4.2-133.5-11.3v32.2a10 10 0 01-20 0v-36.5c-3.4-.8-7.5-2-12-3.3v25a7.5 7.5 0 11-15 0v-30c-18-6.7-37.6-16.5-45.6-29.7l-.1 1.6v47.5c0 10.4 13.9 21.8 38.2 32.1 0 0 60 29.9 188 31a568 568 0 00160-20.5c41.4-12.2 66.2-27.8 66.2-41.6v-48.5c0-.5 0-1-.2-1.6-10 30-107.4 53.6-226 53.6z","fill":"currentColor"}}),_c('path',{attrs:{"d":"M238.8 244.2c-58 1.5-114.8-7.3-159.9-20.6a268.8 268.8 0 01-30-10.6c4.5 31.3 103.8 56.3 225.6 56.3 124.6 0 225.7-26.2 225.7-58.5 0-11.5-12.9-22.2-35.2-31.3v1.5c0 11-15.3 23-42 33.7 0 0-58.7 26.1-184.2 29.5zm-12 151.8c121.8 0 221-25 225.5-56.2-8.6 3.7-18.7 7.3-30 10.6a532.4 532.4 0 01-159.9 20.5C137 367.6 78.2 341.5 78.2 341.5c-26.7-10.7-42-22.8-42-33.7v-1.5C14 315.3 1.1 326 1.1 337.6c0 32.3 101 58.5 225.7 58.5z","fill":"currentColor"}})])
          )
        }
      }
    